// extracted by mini-css-extract-plugin
export default {"root":"CombinedReport_root__hqNsI"};